module.exports = __webpack_public_path__ + "img/cut_sc2.7c24b593.jpg";